import axios from '@/bootstrap'
const endpoint = 'inventory-history-by-stage-set'

export default class InventoryHistoryByStageSetService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }
}
